export default __webpack_public_path__ + "static/media/logo.98171fc0.png";